import XButton from "../common/XButton";
import RenderIf from "../render-if/Renderif";
import useTourReplay from "../../hooks/useTourReplay";

const REPLAY_LABEL = "Replay page tour";

const TourReplayAction = ({ onReplay }) => {
   const { canReplayTour, replayTour } = useTourReplay({ onReplay });

   return (
      <RenderIf shouldRender={canReplayTour}>
         <XButton variant="outlinePrimary" onClick={replayTour}>
            {REPLAY_LABEL}
         </XButton>
      </RenderIf>
   );
};

export default TourReplayAction;
